export default __webpack_public_path__ + "static/logo26-d0748a170d4083f9fd0e4d03c94f7a6f.png";